<form *ngIf="form" [formGroup]="form" (ngSubmit)="onSubmit()" class="mb-5">
  <div class="container mt-3">
    <div class="row">
      <div class="col-12">
        <div class="position-relative input-select">
          <lib-input-select-material-design
            *ngIf="configuracionDePago.habilitarOtroPagador"
            [items]="optionsTarjetaDeCreditoToPagar"
            [control]="controlTarjetaDeCreditoToPagar"
            label="Pagar con la tarjeta de crédito de"
            id="pagar-con-tarjeta-de"
            [wasValidate]="submitted"
            (handleChange)="handleChangeTarjetaDeCreditoParaPagar($event)"
          ></lib-input-select-material-design>
        </div>

        <p
          class="single-payer"
          *ngIf="!configuracionDePago.habilitarOtroPagador"
        >
          {{ configuracionDePago.pagador | titlecase }}, estás a punto de
          realizar tu pago
        </p>
      </div>

      <div
        class="col-12"
        *ngIf="controlTarjetaDeCreditoToPagar.value === OTRA_PERSONA"
      >
        <app-form-datos-otra-persona
          [otraPersonaFormGroup]="getFormGroup(FORM_PAGO_DATOS_OTRA_PERSONA)"
          [submitted]="submitted"
          [tiposDocumento]="maestroFacade.tiposDeDocumento$ | async"
          [ciudades]="maestroFacade.ciudades$ | async"
          (handleFormatDireccion)="handleFormatDireccion()"
        >
        </app-form-datos-otra-persona>
      </div>
      <div
        class="col-12"
        *ngIf="contenidoFacade.contenido$ | async as contenido"
      >
        <app-form-datos-tarjeta-de-credito
          *ngIf="
            resumenDescuentosFacade.resumenDescuentos$ | async;
            let resumenDescuentos
          "
          [tarjetaDeCreditoFormGroup]="
            getFormGroup(FORM_PAGO_DATOS_TARJETA_DE_CREDITO)
          "
          [submitted]="submitted"
          [totalAPagar]="resumenDescuentos.total"
          (activarRenovacionAutomaticaChange)="
            onActivarRenovacionAutomaticaChange($event)
          "
          [contenido]="contenido"
        >
          <app-resumen-descuentos
            *ngIf="
              resumenDescuentos.descuentosAplicados &&
              resumenDescuentos.descuentosAplicados.length
            "
          >
          </app-resumen-descuentos>
        </app-form-datos-tarjeta-de-credito>
      </div>
      <div
        class="col-12 d-flex justify-content-center icono-tarjeta-de-credito mt-4 mb-2"
      >
        <span class="icono-tarjeta-de-credito__exito-mastercard mr-2"></span>
        <span class="icono-tarjeta-de-credito__mastercard mr-2"></span>
        <span class="icono-tarjeta-de-credito__visa mr-2"></span>
        <span class="icono-tarjeta-de-credito__diners-club mr-1"></span>
        <span class="icono-tarjeta-de-credito__amex"></span>
      </div>
      <div class="col-12 text-center my-3">
        <a href="https://www.placetopay.com/web/" target="_blank">
          <img
            src="https://static.placetopay.com/placetopay-logo.svg"
            class="attachment-0x0 size-0x0 logo-placetopay"
            alt="placetopay"
            loading="lazy"
          />
        </a>
      </div>
    </div>
  </div>
</form>
